import { render } from "./TopBarMenu.vue?vue&type=template&id=bbda257e&ts=true&lang=pug"
import script from "./TopBarMenu.vue?vue&type=script&lang=ts"
export * from "./TopBarMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__